import Axios, { AxiosError } from 'axios';
import eventEmitter from '../utils/eventEmitter';

const mountBaseUrl = () => {
  const env = process.env.NODE_ENV;
  if (env === 'development') {
    return 'http://localhost:8000/api';
  }
  return 'https://connect.publisol.com.br/api';
};

// Cria a instância do Axios com credenciais
const api = Axios.create({
  baseURL: mountBaseUrl(),
  withCredentials: true, // Permite envio/recebimento de cookies
});

// Função para verificar se a URL deve ser ignorada pelo interceptor
const isAuthRelatedRequest = (url?: string): boolean => {
  if (!url) return false;
  return url.includes('/auth/') || url.includes('/token/refresh/');
};

// Interceptor de resposta para lidar com 401 e tentar refresh
api.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const originalRequest = error.config;

    // Se a requisição falhou com 401 e não é relacionada a autenticação ou refresh
    if (error.response?.status === 401 && !isAuthRelatedRequest(originalRequest?.url)) {
      // Evita múltiplas tentativas
      if ((originalRequest as any)._retry) {
        // Emite evento de logout
        eventEmitter.emit('logout');
        return Promise.reject(error);
      }

      (originalRequest as any)._retry = true;

      try {
        // Tenta renovar o token
        await api.post('/token/refresh/');
        
        // Repetir a requisição original
        return api(originalRequest!);
      } catch (refreshError) {
        // Se o refresh também falhar, emite evento de logout
        eventEmitter.emit('logout');
        return Promise.reject(refreshError);
      }
    }

    // Se não for 401 ou for uma requisição de autenticação, rejeita o erro
    return Promise.reject(error);
  },
);

export { api };